<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/3 flex lg:mr-3 mb-4"></div>
			<div class="lg:w-2/3 flex justify-end">
				<ButtonBlack class="mr-1">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="comercial_bases"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { queryComercialBaseList } from '@/apollo/queries/admin/comercial_base'

export default {
	apollo: {
		comercial_bases: queryComercialBaseList()
	},
	data() {
		return {
			search: '',
			section: 'base_comercial',
			itemsTable: 'conf_comercial_base',
			itemsTitles: ['Id', 'Base_comercial']
		}
	},
	components: { ListTable }
}
</script>

<style scoped>
.w-24R {
	width: 24rem;
}
</style>
